import React from "react";
import { Clock, Trophy, Star } from "lucide-react";

export default function ResultCard({ kind = "madhur", time, number }) {
  const isStarline = kind === "starline";
  return (
    <div className="relative group">
      <div className="absolute -inset-0.5 rounded-2xl bg-gradient-to-r from-amber-500/30 via-amber-300/20 to-amber-500/30 blur opacity-60 group-hover:opacity-100 transition-opacity" />
      <div className="relative rounded-2xl bg-[#11172a] border border-amber-400/20 p-6 overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-amber-400/5 rounded-full -translate-y-12 translate-x-12 blur-2xl" />
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {isStarline ? (
              <Star className="w-4 h-4 text-amber-300 fill-amber-300" />
            ) : (
              <Trophy className="w-4 h-4 text-amber-300" />
            )}
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-amber-300">
              {isStarline ? "Starline Latest" : "Madhur Latest"}
            </span>
          </div>
          <span className="inline-flex items-center gap-1 text-xs text-slate-400">
            <Clock className="w-3.5 h-3.5" />
            {time}
          </span>
        </div>
        <div className="relative mt-6 text-center">
          <div className="font-mono text-6xl md:text-7xl font-extrabold tracking-tight bg-gradient-to-b from-amber-200 to-amber-500 bg-clip-text text-transparent">
            {number}
          </div>
          <div className="mt-3 text-[11px] uppercase tracking-[0.2em] text-slate-500">Result Declared</div>
        </div>
      </div>
    </div>
  );
}
